import { Seo } from "../components/Seo";

import { useAuth } from "../context/AuthContext";

export default function Account() {
  const { user } = useAuth();

  return (
    <div className="max-w-6xl mx-auto px-6 py-16" data-testid="account-page">
      <Seo title="My Account" description="Your Laura Combs Productions account." path="/account" noindex />
      <span className="text-gold text-sm uppercase tracking-[0.3em]">Your space</span>
      <h1 className="font-serif text-5xl text-forest mt-3 mb-2">Hello, {user?.name?.split(" ")[0]}</h1>
      <p className="text-charcoal/60 mb-12">Welcome back to your calm corner of the web.</p>

      <div className="bg-white rounded-2xl border border-gold/30 p-8" data-testid="account-details">
        <h2 className="font-serif text-2xl text-forest mb-6">Account Details</h2>
        <dl className="divide-y divide-gold/20">
          <div className="flex items-center justify-between py-4">
            <dt className="text-charcoal/60">Name</dt>
            <dd className="text-charcoal font-medium" data-testid="account-name">{user?.name}</dd>
          </div>
          <div className="flex items-center justify-between py-4">
            <dt className="text-charcoal/60">Email</dt>
            <dd className="text-charcoal font-medium" data-testid="account-email">{user?.email}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
}
